import moment from 'moment-timezone'
import { cleanProviderName } from '../../new-visit/helper'

// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
function padZeroesEnd(number) {
  return number.toString().padEnd(2, '0')
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const getTimezoneOffset = (timezoneName) => {
  try {
    const date = moment().tz(timezoneName)

    const offsetForSign = date.utcOffset() / 60
    const offsetForCalculation = Math.abs(date.utcOffset() / 60)
    const offsetHours = Math.floor(offsetForCalculation)
    const offsetMinutes = (offsetForCalculation - offsetHours) * 60
    const offsetSign = offsetForSign < 0 ? '-' : '+'

    return `${offsetSign}${offsetHours}:${padZeroesEnd(offsetMinutes)}`
  } catch (error) {
    return null
  }
}

export const fullNameGenerator = ({ FirstName = '', LastName = '', Prefix = '', Suffix = '' }) => {
  const rawName = `${Prefix && `${Prefix} `}${FirstName} ${LastName} ${Suffix}`

  return cleanProviderName(rawName)
}
// @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
export const phoneTextGenerator = (phoneNumberObject) => {
  if (phoneNumberObject) {
    return `${phoneNumberObject?.Prefix} ${phoneNumberObject?.Number.substr(phoneNumberObject?.Prefix?.length)}`
  }
  return '--'
}
